<button type="button" class="template-trigger-button" mat-icon-button matTooltip="Select Template" [matMenuTriggerFor]="templatesPopup" #triggerMenu='matMenuTrigger' (menuOpened)="menuOpened()">
  <i class="material-icons">quickreply</i>
</button>

<mat-menu #templatesPopup class="templates-popup menu-no-paddings" >
  <mat-card class="template-popup-menu">
    <mat-card-content fxLayout="column" class="template-popup-body">
      <mat-button-toggle-group fxLayout="row" #filterTypeGroup="matButtonToggleGroup" [(value)]="filterType">
        <mat-button-toggle class="template-popup-tab" fxFlex="auto" value="0" aria-label="All" (click)="filterByType($event, '0')">
          All
        </mat-button-toggle>
        <mat-button-toggle class="template-popup-tab" fxFlex="auto" value="1" aria-label="Public" (click)="filterByType($event, '1')">
          Public
        </mat-button-toggle>
        <mat-button-toggle class="template-popup-tab" fxFlex="auto" value="2" aria-label="Private" (click)="filterByType($event, '2')">
          Private
        </mat-button-toggle>
      </mat-button-toggle-group>
      <mat-selection-list fxFlex="auto" class="templates-list" [multiple]="false" [hideSingleSelectionIndicator]="true">
        <cdk-virtual-scroll-viewport itemSize="48" class="templates-viewport">
          <mat-list-option *cdkVirtualFor="let dataItem of templatesDataSource">
            <div fxLayout="row" (click)="onItemClick($event, dataItem)" class="list-item">
              <div [fxFlex]="(dataItem.isPublic && hasEditAccess) || (hasPrivateEditAccess && !dataItem.isPublic) ? 'calc(100% - 40px)' : '100'"
                   [matTooltip]="dataItem.message?.substring(0, 300)" matTooltipPosition="left">
                <div class="list-item-title"><b>{{dataItem.name}}</b></div>
                <div class="list-item-content">{{dataItem.message}}</div>
              </div>
              <button mat-icon-button matTooltip="Edit Template" class="button-40"
                      *ngIf="(dataItem.isPublic && hasEditAccess) || (hasPrivateEditAccess && !dataItem.isPublic)"
                      (click)="editTemplate($event, dataItem.id)">
                <mat-icon>mode_edit</mat-icon>
              </button>
            </div>
          </mat-list-option>
        </cdk-virtual-scroll-viewport>
      </mat-selection-list>
    </mat-card-content>
    <mat-card-actions class="template-popup-actions">
      <mat-form-field class="no-underline no-hint" (click)="$event.stopPropagation();">
        <mat-label>Search</mat-label>
        <input matInput type="text" autocomplete="off" [ngModel]="searchText" (ngModelChange)="onSearchChange($event)">
        <button mat-mini-fab color="primary" matSuffix class="button-40 no-shadow"
                *ngIf="hasEditAccess || hasPrivateEditAccess"
                matTooltip="Add new template"
                (click)="editTemplate($event,'new')" [attr.aria-label]="'Add new template'">
          <mat-icon>add</mat-icon>
        </button>
      </mat-form-field>
    </mat-card-actions>
  </mat-card>
</mat-menu>
